import { RootStore } from '@/store';

import Create from '@/components/Tabs/components/Tab/images/create.svg?react';
import Opinions from '@/components/Tabs/components/Tab/images/opinions.svg?react';
import Polls from '@/components/Tabs/components/Tab/images/polls.svg?react';
import Profile from '@/components/Tabs/components/Tab/images/profile.svg?react';
import Tournaments from '@/components/Tabs/components/Tab/images/tournaments.svg?react';
import { Params } from 'react-router-dom';

export type RouteConfigItem = {
  path: string;
  title: string;
  backTo: string | null;
  lightHeader?: boolean;
  hideTabs?: boolean;
  tabIcon?: React.FC;
  hasBackButton?: boolean | ((params: Params, rootStore: RootStore) => boolean);
};

export const ROUTES_CONFIG = {
  EGG: {
    path: 'games/egg',
    title: 'Egg Game',
    backTo: 'GAMES',
  },
  WALLET: {
    path: 'wallet',
    title: 'Wallet',
    backTo: 'GAMES',
  },
  PROFILE_ID: {
    path: 'profile/:id',
    title: 'Profile',
    backTo: 'GAMES',
    tabIcon: Profile,
    hasBackButton: (params: Params, rootStore: RootStore) =>
      params.id !== rootStore.accountStore.accountData._id,
  },
  PROFILE_ID_OPINION_ID: {
    path: 'profile/:id/opinions/:opinionId',
    title: 'Opinion',
    backTo: 'PROFILE_ID',
    hasBackButton: true,
  },
  POLLS: {
    path: 'polls',
    title: 'Polls',
    backTo: 'GAMES',
    tabIcon: Polls,
  },
  POLL_ID: {
    path: 'polls/:id',
    title: 'Polls',
    backTo: 'GAMES',
  },
  LEADERBOARD: {
    path: 'leaderboard',
    title: 'Leaderboard',
    backTo: 'GAMES',
  },
  OPINION_ID: {
    path: 'opinions/:id',
    title: 'Opinion Details',
    backTo: 'POLLS',
    hasBackButton: true,
    hideTabs: true,
  },
  TASKS: {
    path: 'tasks',
    title: 'Tasks & Rewards',
    backTo: 'GAMES',
  },
  CREATE_OPINION: {
    path: 'opinions/create',
    title: 'Create Opinion',
    backTo: 'UGC',
    lightHeader: true,
    hasBackButton: true,
    hideTabs: true,
  },
  CREATE_POLL: {
    path: 'polls/create',
    title: 'Create Poll',
    backTo: 'UGC',
    lightHeader: true,
    hasBackButton: true,
    hideTabs: true,
  },
  TOURNAMENTS: {
    path: 'tournaments',
    title: 'Tournaments',
    backTo: 'GAMES',
    tabIcon: Tournaments,
  },
  TOURNAMENT_ID: {
    path: 'tournaments/:id',
    title: 'Tournament Details',
    backTo: 'TOURNAMENTS',
    hasBackButton: true,
  },
  TOURNAMENT_ID_OPINION_ID: {
    path: 'tournaments/:id/opinions/:opinionId',
    title: 'Tournament Opinion',
    backTo: 'TOURNAMENT_ID',
    hasBackButton: true,
  },
  OPINIONS: {
    path: 'opinions',
    title: 'Opinions',
    backTo: 'GAMES',
    tabIcon: Opinions,
  },
  UGC: {
    path: 'create',
    title: 'Create',
    backTo: 'OPINIONS',
    lightHeader: true,
    hasBackButton: true,
    tabIcon: Create,
  },
  CREATE_TOURNAMENT: {
    path: 'tournaments/create',
    title: 'Create Tournament',
    backTo: 'TOURNAMENTS',
    lightHeader: true,
    hasBackButton: true,
    hideTabs: true,
  },
  SIGN_IN: {
    path: 'login',
    title: 'Sign In',
    backTo: null,
    hasBackButton: true,
  },
  WALLET_WITHDRAW_SELECT: {
    path: 'wallet/withdraw',
    title: 'Withdraw Selection',
    backTo: 'WALLET',
    hasBackButton: true,
  },
  WALLET_WITHDRAW_FORM: {
    path: 'wallet/withdraw/:code',
    title: 'Withdraw Form',
    backTo: 'WALLET_WITHDRAW_SELECT',
    hasBackButton: true,
  },
  WALLET_DEPOSIT_SELECT: {
    path: 'wallet/deposit',
    title: 'Deposit Selection',
    backTo: 'WALLET',
    hasBackButton: true,
  },
  WALLET_DEPOSIT_METHOD_SELECT: {
    path: 'wallet/deposit/:code',
    title: 'Deposit Selection',
    backTo: 'WALLET_DEPOSIT_SELECT',
    hasBackButton: true,
  },
  WALLET_EXTERNAL_DEPOSIT: {
    path: 'wallet/deposit/:code/external',
    title: 'Deposit Selection',
    backTo: 'WALLET_DEPOSIT_SELECT',
    hasBackButton: true,
  },
  WALLET_DEPOSIT_FORM: {
    path: 'wallet/deposit/:code/internal',
    title: 'Deposit Selection',
    backTo: 'WALLET_DEPOSIT_SELECT',
    hasBackButton: true,
  },
  WALLET_TRANSACTION_FINISH: {
    path: 'wallet/finish',
    title: 'Transaction Complete',
    backTo: 'WALLET',
    hasBackButton: true,
  },
  WALLET_TRANSACTIONS_HISTORY: {
    path: 'wallet/history',
    title: 'Transaction History',
    backTo: 'WALLET',
    hasBackButton: true,
  },
} as {
  [key: string]: RouteConfigItem;
};

export const PAGE = Object.fromEntries(
  Object.entries(ROUTES_CONFIG).map(([key, value]) => [key, value.path]),
) as { [K in keyof typeof ROUTES_CONFIG]: string };
